<template>
  <div>
    <ShipmentDetail
      :shipmentCode="shipmentCode"
      ref="shipmentDetail"
      :disabled="disabled"
      readonly
    />
  </div>
</template>
<script>
import ShipmentDetail from '@/views/factory/transport/components/shipment-detail'
export default {
  name: 'transport-wait-settlement-detail',
  components: {
    ShipmentDetail,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    shipmentCode() {
      return this.params.code
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
